module.exports = __webpack_public_path__ + "img/tiktok-thumb.1b08b7da.jpg";